import { type ReactNode, useMemo, useState } from 'react';
import { NotificationContext, type Notification, type NotificationContextValue } from '@/app/providers/notifications';

export function NotificationProvider({ children }: { children: ReactNode }) {
  const [notifications, setNotifications] = useState<Notification[]>([]);

  const value = useMemo<NotificationContextValue>(() => ({
    notifications,
    pushNotification: (notification: Omit<Notification, 'id'>) => {
      const id =
        typeof crypto !== 'undefined' && 'randomUUID' in crypto
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random()}`;
      const composed = { ...notification, id } satisfies Notification;
      setNotifications((prev) => [...prev, composed]);
      // Always auto-dismiss after 5s so a toast never lingers until manually
      // closed (clicking it still dismisses immediately).
      setTimeout(() => {
        setNotifications((prev) => prev.filter((item) => item.id !== id));
      }, 5000);
    },
    dismissNotification: (id: string) => {
      setNotifications((prev) => prev.filter((item) => item.id !== id));
    },
  }), [notifications]);

  return <NotificationContext.Provider value={value}>{children}</NotificationContext.Provider>;
}